import { render } from "./ReportApproveRatioTd.vue?vue&type=template&id=1e4f07c7"
import script from "./ReportApproveRatioTd.vue?vue&type=script&lang=js"
export * from "./ReportApproveRatioTd.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__